export default {
  state: () => ({
    manufacturers: [],
  }),
  mutations: {
    UPDATE_MANUFACTURERS(state, value) {
      state.manufacturers = value
    },
  },
}
